<template>
<div class="course-list section-holder container">
        <div class="row pb-4 justify-content-end">
            <h6 class="col-md-6 text-left"><strong>{{$t('course.course_description')}}</strong></h6>
            <h6 class="col-md-6 text-right"><a href="#"> <strong>{{$t('download_syllabus')}}</strong> </a>
            </h6> 
        </div>
    <div class="card">
        <div class="row">
            <div class="col-2 video-col">
                <video class="video-css" poster="../../static/assets/images/8.jpg">
                    <source src="../../../static/assets/images/a.mp4" type="video/mp4">
                    {{$t('common.errors.videoTagError')}}
                </video>
                <span class="play-icon"><i class="mdi mdi-play-circle"></i></span>
            </div>
            <div class="col-7 description">
                <h5>Topic1</h5>
                <p>What is user going to learn in this topic, what are the take aways from this topic.
                    A short note about the topic<br/>What is user going to learn in this topic, what are the take aways from this topic
                    A short note about the topic
                </p>
            </div>
        </div>
        <div><hr/></div>
        <div class="row">
            <div class="col-2 video-col">
                <video class="video-css" width="100%" height="240" poster="../../static/assets/images/ref2.png">
                    <source src="../../../static/assets/images/a.mp4" type="video/mp4">
                     {{$t('common.errors.videoTagError')}}
                </video>
                <span class="play-icon"><i class="mdi mdi-play-circle"></i></span>
            </div>
            <div class="col-7 description">
                <h5>Topic1</h5>
                <p>What is user going to learn in this topic, what are the take aways from this topic.
                    A short note about the topic<br/>What is user going to learn in this topic, what are the take aways from this topic
                    A short note about the topic
                </p>
            </div>
        </div>
    </div>
 </div>
</template>

<script>
export default {
  name: 'courseList',
  data () {
    return {
    }
  }
}
</script>
<style lang="scss">
.course-list{
    .card{
        border-radius: 3px;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.18);
        border: none;
        background-color: #fff;
        transition: box-shadow .25s;
        margin-bottom:25px;
        padding:25px;
        .divider{border: 0.5px solid #eee; margin:20px -25px; }
        .row { 
            .video-col { 
                .video-css{ 
                    object-fit:cover;
                    width:100%; 
                    height:152px; 
                    border-radius: 3px; 
                }
                .overlay{ 
                    width:100%; height:100%;
                    top:0px;   
                    border-radius:3px;
                    position: absolute;
                    z-index:2;
                    background: linear-gradient(to right, rgba(92, 184, 234,0.9) 0%,rgba(110, 99, 197, 0.9) 100%);
                }
            }
        }
        .description{
            h5{color:#333; font-size:14px; line-height:25px;}
            p{color:#555; font-size:12px;}
        }
        .play-icon{
                display:none;
                top:48%;
                left:42%;
                position: absolute;
                z-index:2;
                .fa{
                font-size:45px;
                line-height: 0px;
                color: rgba(255, 255, 255, .7)
                }
            }
            .video-col{
                &:hover { 
                .fa {
                    color:rgba(255,255,255,0.9); }}
            }
    &:hover {
            cursor: pointer;
            transition: box-shadow .45s;
             box-shadow: 0px 15px 25px rgba(0, 0, 0, .25);
    }
}
}
</style>



// WEBPACK FOOTER //
// src/components/course/courseList.vue?32a92c81